export default "__VITE_ASSET__DBy9650K__"